module.exports = __webpack_public_path__ + "static/img/article_type2_top_img.d57274c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/article_type2_top_img.jpg
// module id = 2hrz
// module chunks = 0